import { generatePath } from "@routes/utils";

const pathBase = `/auth/otp/request/`;

export const request = {
  post: () => generatePath(pathBase, null),
};
